








/* Created- 23 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ContentSearchHit } from "../../../Generated/ParticaAPI";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";


@Component(
	{
		name: "ArticleActions",
		components: { ButtonList, ParticaCard }
	})
export default class ArticleActions extends Vue {
	@Prop() private article: ContentSearchHit; // your data     
	@Prop({ default: true }) private edit: boolean;
	private buttons: ButtonConfig[] = [
		{
			label: "Go to issue",
			action: eParticaAction.ISSUE_SELECT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Edit",
			action: eParticaAction.ARTICLE_EDIT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Preview",
			action: eParticaAction.ARTICLE_PREVIEW,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Licence",
			action: eParticaAction.VIEW_ARTICLE_LICENCE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private clicked(event: ParticaEvent) {
		event.item = this.article;
		this.$emit("partica-event", event);
	}

	@Watch("article")
	private articleChange() {
		if (this.article !== undefined) {
			switch (this.article.articleType) {
				case 5: // syndication
				case 6: { // syndication proof
					this.buttons[3].status = ButtonStatus.Enabled;
					break;
				}
				default: {
					this.buttons[3].status = ButtonStatus.Disabled;
					break;
				}
			}
		}
	}

	private mounted() {
		this.articleChange();
		if (this.edit === false) {
			this.buttons[1].status = ButtonStatus.Disabled;
		}
	}
}
